import {Promotion} from '../../types/singleModelInterface'

const normalizeTag = (tag: string | null | undefined): string =>
    (tag ?? '').trim().toLowerCase()

/**
 * Finds the promotion a campaign landing refers to: the one whose
 * `form_opening_tag`, set in the backend, matches the value of `promo-app` in
 * the URL (e.g. `adv`, `crm`). Campaign URLs are written before the promotions
 * exist, so they carry this tag instead of an id or a slug.
 *
 * @param promotions Promotions of the model, in the order shown on the page
 * @param rawTag Tag read from the URL
 * @returns The first promotion with that tag, `undefined` if there is none
 */
export function findPromotionByFormOpeningTag(
    promotions: Promotion[] | undefined,
    rawTag: string | null
): Promotion | undefined {
    const tag = normalizeTag(rawTag)

    if (!tag || !promotions?.length) {
        return undefined
    }

    return promotions.find(
        (promotion) => normalizeTag(promotion.form_opening_tag) === tag
    )
}
